import { render, staticRenderFns } from "./Close.vue?vue&type=template&id=1398a990"
import script from "./Close.vue?vue&type=script&lang=js"
export * from "./Close.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1398a990')) {
      api.createRecord('1398a990', component.options)
    } else {
      api.reload('1398a990', component.options)
    }
    module.hot.accept("./Close.vue?vue&type=template&id=1398a990", function () {
      api.rerender('1398a990', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/Close.vue"
export default component.exports